import { NgModule } from '@angular/core';
import { BackendModule } from '@freelancer/datastore/core';
import { StoreModule } from '@ngrx/store';
import { superuserRolesBackend } from './superuser-roles.backend';
import { superuserRolesReducer } from './superuser-roles.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('superuserRoles', superuserRolesReducer),
    BackendModule.forFeature('superuserRoles', superuserRolesBackend),
  ],
})
export class DatastoreSuperuserRolesModule {}
